import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import dynamic from 'next/dynamic';
import React, { useRef, forwardRef } from 'react';
import { Skeleton } from 'antd';
import { useEffect } from 'react'; // TODO: Remove those comments

import { jsx as _jsx } from "react/jsx-runtime";
var QuillEditor = dynamic(function () {
  return import('./quillEditor').then(function (mod) {
    return mod["default"];
  });
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/_jsx(Skeleton, {
      active: true
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./quillEditor')];
    },
    modules: ["../../../../modules/form-components/src/rich-text-editor/rich-text-editor.component.tsx -> " + './quillEditor']
  }
}); // eslint-disable-next-line react/display-name

var ForwardedRefComponent = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(QuillEditor, _objectSpread(_objectSpread({}, props), {}, {
    placeholder: props.placeholder,
    forwardedRef: ref,
    readOnly: props.previewMode,
    onShowingUploadModal: props.onShowingUploadModal,
    onShowingAudioUploadModal: props.onShowingAudioUploadModal
  }));
});
export var RichTextEditor = function RichTextEditor(props) {
  var refTextEditor = useRef();
  useEffect(function () {
    var timeoutId;

    var focusEditor = function focusEditor() {
      if (refTextEditor.current) {
        if (props.editorRef) {
          var _props$setIsEditorRea;

          props.editorRef.current = refTextEditor.current;
          (_props$setIsEditorRea = props.setIsEditorReady) === null || _props$setIsEditorRea === void 0 ? void 0 : _props$setIsEditorRea.call(props, true);
        }

        var quillInstance = refTextEditor.current.getEditor();

        if (props.shouldAutoFocus) {
          var length = quillInstance.getLength();
          quillInstance.setSelection(length, 0);
        }
      } else {
        timeoutId = setTimeout(focusEditor, 100);
      }
    };

    focusEditor();
    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId); // Cleanup timeout on unmount
      }
    };
  }, [props.editorRef, props.shouldAutoFocus]);
  return /*#__PURE__*/_jsx(ForwardedRefComponent, _objectSpread(_objectSpread({}, props), {}, {
    ref: refTextEditor
  }));
};